import Vue from 'vue'
import VueRouter from 'vue-router'
import Alunos from '@/views/Alunos'
// import About from '@/views/About'
import Auth from '@/auth/Auth'
import Empresas from '@/views/Empresas'
import Home from '@/views/Home'
import Professores from '@/views/Professores'
import Usuarios from '@/views/Usuarios'
import EditaServicePainel from '@/views/EditaServicePainel'
import Paineis from '@/views/Paineis'
import EditaServiceProfessor from '@/views/EditaServiceProfessor'
import Resultados from '@/views/Resultados'
import Avaliacao from '@/views/Avaliacao'
import Totens from '@/views/Totens'
import PontoEletronico from '@/views/PontoEletronico'
import Planos from '@/views/Planos'
import LandingPage from '@/views/LandingPage'
import Auditoria from '@/views/Auditoria'
import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'landing', path: '/', component: LandingPage, meta: { requiresAdmin: false } },
  { name: 'alunos', path: '/alunos', component: Alunos, meta: { requiresAdmin: true } },
  // { name: 'about', path: '/about', component: About, meta: { requiresAdmin: false } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'professores', path: '/professores', component: Professores, meta: { requiresAdmin: true } },
  { name: 'usuarios', path: '/usuarios', component: Usuarios, meta: { requiresAdmin: true } },
  { name: 'editaservicepainel', path: '/editaservicepainel', component: EditaServicePainel, meta: { requiresAdmin: true } },
  { name: 'paineis', path: '/paineis', component: Paineis, meta: { requiresAdmin: true } },
  { name: 'editaserviceprofessor', path: '/editaserviceprofessor', component: EditaServiceProfessor, meta: { requiresAdmin: true } },
  { name: 'resultados', path: '/resultados', component: Resultados, meta: { requiresAdmin: true } },
  { name: 'avaliacao', path: '/avaliacao', component: Avaliacao, meta: { requiresAdmin: false } },
  { name: 'totens', path: '/totens', component: Totens, meta: { requiresAdmin: true } },
  { name: 'PontoEletronico', path: '/pontoeletronico', component: PontoEletronico, meta: { requiresAdmin: true } },
  { name: 'planos', path: '/planos', component: Planos, meta: { requiresAdmin: true } },
  { name: 'auditoria', path: '/auditoria', component: Auditoria, meta: { requiresAdmin: true } },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "RECEPCAO")
      next()
    else
      next({ path: '/login' })
  } else {
    next()
  }
})

export default router